var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgCup = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax/linear/cup"
  }, /*#__PURE__*/React.createElement("g", {
    id: "cup"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M10.125 13.75V15.5",
    stroke: "#7E7E80",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M5.95703 18.333H14.2904V17.4997C14.2904 16.583 13.5404 15.833 12.6237 15.833H7.6237C6.70703 15.833 5.95703 16.583 5.95703 17.4997V18.333V18.333Z",
    stroke: "#7E7E80",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M5.125 18.333H15.125",
    stroke: "#7E7E80",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M10.0013 13.3337C6.7763 13.3337 4.16797 10.7253 4.16797 7.50033V5.00033C4.16797 3.15866 5.65964 1.66699 7.5013 1.66699H12.5013C14.343 1.66699 15.8346 3.15866 15.8346 5.00033V7.50033C15.8346 10.7253 13.2263 13.3337 10.0013 13.3337Z",
    stroke: "#7E7E80",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M4.55755 9.70833C3.93255 9.50833 3.38255 9.14167 2.94922 8.70833C2.19922 7.875 1.69922 6.875 1.69922 5.70833C1.69922 4.54167 2.61589 3.625 3.78255 3.625H4.32422C4.15755 4.00833 4.07422 4.43333 4.07422 4.875V7.375C4.07422 8.20833 4.24922 8.99167 4.55755 9.70833Z",
    stroke: "#7E7E80",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M15.4414 9.70833C16.0664 9.50833 16.6164 9.14167 17.0497 8.70833C17.7997 7.875 18.2997 6.875 18.2997 5.70833C18.2997 4.54167 17.3831 3.625 16.2164 3.625H15.6747C15.8414 4.00833 15.9247 4.43333 15.9247 4.875V7.375C15.9247 8.20833 15.7497 8.99167 15.4414 9.70833Z",
    stroke: "#7E7E80",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgCup, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/cup.96ff37c1.svg";
export { ForwardRef as ReactComponent };